module.exports = __webpack_public_path__ + "img/superintendent.067156ad.png";